<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col lg="3" md="2" cols="12">
                      <v-date-input
                        label="Effective From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="3" md="2" cols="12">
                      <v-date-input
                        label="Effective To Date"
                        density="compact"
                        single-line
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Evaluation Criteria List</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/purchase/add-evaluation')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                      >
                        Create Evaluation Criteria
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                  show-expand
                  item-key="id"
                  class="elevation-1"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.approved_ind="{ item }">
                    <v-chip
                      v-if="item.approved_ind == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Yes</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >No</v-chip
                    >
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Active</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >Inactive</v-chip
                    >
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      class="me-2 edit-button"
                      color="primary"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath)"
                    >
                      mdi mdi-pencil-outline
                    </v-icon>
                  </template>
                  <template v-slot:expanded-row="{ item, columns }">
                    <tr>
                      <td :colspan="columns.length">
                        <v-card
                          flat
                          class="ma-2 pa-2 rounded"
                          color="grey-lighten-4"
                        >
                          <div
                            class="text-subtitle-2 text-center text-decoration-underline mb-2"
                          >
                            Evaluation Criteria Details
                          </div>
                          <v-data-table
                            :headers="detailHeaders"
                            :items="item.evaluation_criteria"
                            density="compact"
                            class="elevation-1 pa-2 rounded"
                            hide-default-footer
                          >
                            <!-- Sl -->
                            <template v-slot:item.sl="{ item }">
                              {{ item.id }}
                            </template>
                          </v-data-table>
                        </v-card>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    headers: [
      {
        title: "#SL",
        align: "center",
        key: "index",
        width: "7%",
        sortable: false,
      },
      { title: "Name", key: "name", align: "left", sortable: false },
      {
        title: "Effective From Date",
        key: "effective_from_date",
        align: "left",
        sortable: false,
      },
      {
        title: "Effective To Date",
        key: "effective_to_date",
        align: "left",
        sortable: false,
      },
      { title: "Remarks", key: "remarks", align: "left", sortable: false },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
    detailHeaders: [
      { title: "SL", align: "center", key: "sl", width: "7%" },
      { title: "Field Name", align: "center", key: "field_name" },
      { title: "Weight Percent", align: "center", key: "weight_percent" },
    ],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getEvaluationCriteriaList.length == 0) {
      this.$store.dispatch("getEvaluationCriteriaList");
    }
  },
  computed: {
    getSchema() {
      return this.$store.getters.getEvaluationCriteriaList || [];
    },
    getEvaluationCriteriaList() {
      let data = this.$store.getters.getEvaluationCriteriaList;
      if (data.length > 0) {
        return data.filter((item) => item.status == 1);
      }
      return [];
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({}),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
       values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getEvaluationCriteriaList", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submit,
      from_date,
      to_date,
      errorMessages,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      this.$router.push({
        name: "add-evaluation",
        query: { id: item.id },
      });
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Name",
        "Effective From Date",
        "Effective To Date",
        "Remarks",
        "Status",
      ];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.name,
        item.effective_from_date,
        item.effective_to_date,
        item.remarks,
        item.status == 1 ? "Active" : "Inactive",
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Evaluation List",
        "evaluation_list_" + this.$fileDate(),
        "landscape"
      );
    },
    exportToExcel() {
      var data = [
        [
          "#SL",
          "Name",
          "Effective From Date",
          "Effective To Date",
          "Remarks",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.name,
          item.effective_from_date,
          item.effective_to_date,
          item.remarks,
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });
      this.$exportTableToExcel(data, "evaluation_list_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [
          "#SL",
          "Name",
          "Effective From Date",
          "Effective To Date",
          "Remarks",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.name,
          item.effective_from_date,
          item.effective_to_date,
          item.remarks,
          item.status == 1 ? "Active" : "Inactive",
        ]);
      });

      this.$exportTableToCSV(data, "evaluation_list_" + this.$fileDate());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
